import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=2e98e6c7&scoped=true"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=2e98e6c7&prod&lang=scss&scoped=true"
import style1 from "./BasePhoneInput.vue?vue&type=style&index=1&id=2e98e6c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98e6c7",
  null
  
)

export default component.exports